module.exports = (__webpack_require__(2))(72);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/UploadWidget.js from dll-reference girder_lib
// module id = 44
// module chunks = 0